import { render } from "./UserDetails.vue?vue&type=template&id=b3fa58c0&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"

import "./UserDetails.vue?vue&type=style&index=0&id=b3fa58c0&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3fa58c0"]])

export default __exports__